import { useFormContext } from "react-hook-form";
import { t } from "@/i18n-js/instance";
import { defaultBadge } from "@circle-react/helpers/paywallCustomizationHelpers";
import { useCheckoutTabContext } from "../../CheckoutTabContext";
import { localeRoot } from "../../constants";
import { BadgeForm } from "./Forms/BadgeForm";
import { AddButton } from "./components/AddButton";
import { ContainerForm } from "./components/ContainerForm";
import { FormGroup } from "./components/FormGroup";
import { FormItemGroup } from "./components/FormItemGroup";

const toggleDataTestId = "paywall-customization-badge-toggle";
const containerDataTestId = "paywall-customization-badge-container";

export const BadgeProperties = () => {
  const { watch, getValues } = useFormContext();
  const { badgePropertiesForm } = useCheckoutTabContext();

  const { fields, append, remove } = badgePropertiesForm || {
    fields: [],
    append: () => {},
    remove: () => {},
  };

  const isEnabled = Boolean(
    watch("paywall_customization_attributes.badge_properties.enabled"),
  );
  const hasReachedLimit = fields.length >= 5;
  const hasReachedMinimum = fields.length <= 1;
  const onAddItem = () => append(defaultBadge);

  return (
    <ContainerForm
      titleLocale={t([localeRoot, "builder.badges.show_badges"])}
      toggleName="paywall_customization_attributes.badge_properties.enabled"
      toggleDataTestId={toggleDataTestId}
      containerDataTestId={containerDataTestId}
    >
      <FormGroup
        data-testid="badge-properties-form-group"
        isEnabled={isEnabled}
      >
        {fields.map((field, index: number) => {
          const formName = `paywall_customization_attributes.badge_properties.badges.${index}`;
          const onDuplicateClick = () => append(getValues(formName));
          const onRemoveClick = () => remove(index);

          return (
            <FormItemGroup
              key={field.id}
              index={index}
              fields={fields}
              hasReachedLimit={hasReachedLimit}
              hasReachedMinimum={hasReachedMinimum}
              onDuplicateClick={onDuplicateClick}
              onRemoveClick={onRemoveClick}
              title={t("badge")}
              dataTestId="badge-form-item-group"
            >
              <BadgeForm
                keyFormId={field.id}
                name={formName}
                disabled={!isEnabled}
              />
            </FormItemGroup>
          );
        })}
      </FormGroup>
      <AddButton
        label={t([localeRoot, "builder.badges.add_badge"])}
        onClick={onAddItem}
        disabled={hasReachedLimit || !isEnabled}
        dataTestId="add-badge-button"
      />
    </ContainerForm>
  );
};
